export default (theme) => ({
  portalFormWrapper: {
    position: 'relative',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
    maxWidth: 677,
    width: '100%',
    height: 'auto',
    borderRadius: 33,
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    padding: '20px 40px',
    [theme.breakpoints.down('xl')]: {
      maxWidth: 585,
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(100% - 90px)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: 20,
      maxWidth: 'calc(100% - 36px)',
    },
  },
});
